import React from 'react'

const Icon = (props) => {
  const { name, classSvg, additional } = props
  switch (name) {
    case 'compare':
      return (
        <svg
          width='32'
          height='32'
          viewBox='0 0 32 32'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M7.53141 11.9696L7 12.5003L7.53142 13.0309L11.5069 17.001L12.5668 15.9396L9.87458 13.251L18.0614 13.251L18.0614 11.751L9.873 11.751L12.5668 9.06092L11.5069 7.99953L7.53141 11.9696Z'
            fill='#C3C8CF'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M24.5291 20.0314L25.0605 19.5007L24.5291 18.97L20.5537 15L19.4938 16.0614L22.186 18.7499L13.9992 18.7499L13.9992 20.2499L22.1875 20.2499L19.4937 22.9401L20.5537 24.0014L24.5291 20.0314Z'
            fill='#C3C8CF'
          />
        </svg>
      )
    case 'user':
      return (
        <svg
          className={`svg-icon svg-icon_user ${classSvg}`}
          viewBox='0 0 40 40'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z' />
          <path d='M34.7114 33.5483C31.0566 37.515 25.8181 40 19.9992 40C14.1803 40 8.94185 37.515 5.28711 33.5483C9.67738 31.2876 14.6877 30 19.9992 30C25.3108 30 30.3211 31.2876 34.7114 33.5483Z' />
          <circle cx='20' cy='20' r='19' />
          <circle cx='20' cy='16' r='10' />
        </svg>
      )
    case 'chevron':
      return (
        <svg
          className={`svg-icon svg-icon_chevron ${classSvg}`}
          viewBox='0 0 12 12'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M2 4L6 8L10 4' />
        </svg>
      )
    case 'chevron-black':
      return (
        <svg
          className={`svg-icon svg-icon_chevron ${classSvg}`}
          viewBox='0 0 12 12'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M2 4L6 8L10 4' style={{ stroke: '#474c58' }} />
        </svg>
      )
    case 'menu':
      return (
        <svg
          className={`svg-icon svg-icon_menu ${classSvg}`}
          viewBox='0 0 24 24'
          xmlns='http://www.w3.org/2000/svg'
        >
          <rect x='2' y='6' width='20' height='2' rx='1' />
          <rect x='2' y='11' width='20' height='2' rx='1' />
          <rect x='2' y='16' width='20' height='2' rx='1' />
        </svg>
      )
    case 'spy':
      return (
        <svg
          width='31'
          height='30'
          viewBox='0 0 31 30'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          className={`${classSvg}`}
        >
          <path
            d='M15.3047 30C23.589 30 30.3047 23.2843 30.3047 15C30.3047 6.71573 23.589 0 15.3047 0C7.02042 0 0.304688 6.71573 0.304688 15C0.304688 23.2843 7.02042 30 15.3047 30Z'
            fill='#E4E6EE'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M11.1781 8C9.37207 8 9.37207 14.51 9.37207 14.51C9.96959 14.5597 10.5676 14.6018 11.1659 14.6362C9.33782 14.5339 7.51356 14.3657 5.6967 14.1319C5.64773 14.1249 5.5978 14.1285 5.55036 14.1425C5.50291 14.1566 5.45906 14.1807 5.42182 14.2133C5.38458 14.2459 5.35483 14.2861 5.33462 14.3313C5.3144 14.3765 5.3042 14.4255 5.30471 14.4749V14.9299C5.30557 15.0155 5.33715 15.0979 5.39368 15.1622C5.45021 15.2264 5.52794 15.2682 5.6127 15.2799C8.78483 15.7046 11.9813 15.922 15.1817 15.9309C18.3816 15.929 21.578 15.7185 24.7506 15.3009C24.8354 15.2892 24.9131 15.2474 24.9696 15.1832C25.0262 15.1189 25.0577 15.0365 25.0586 14.9509V14.4959C25.0623 14.4447 25.0544 14.3934 25.0356 14.3456C25.0168 14.2978 24.9875 14.2549 24.9499 14.2199C24.9123 14.185 24.8673 14.159 24.8183 14.1437C24.7692 14.1285 24.7174 14.1245 24.6666 14.1319C22.8595 14.3645 21.045 14.5321 19.2268 14.6345C19.8155 14.6005 20.404 14.5589 20.992 14.51C20.992 14.51 20.992 8 19.186 8C18.1454 8 17.3373 8.73899 16.6302 9.38547C16.1102 9.861 15.6449 10.2865 15.182 10.331C14.6913 10.3782 14.1977 9.91216 13.639 9.3847C12.9546 8.73847 12.1724 8 11.1781 8ZM16.6357 14.7364C15.6629 14.7566 14.6898 14.7565 13.717 14.7362C14.2051 14.7471 14.6933 14.7534 15.1817 14.7549C15.6664 14.7534 16.1511 14.7472 16.6357 14.7364Z'
            fill='#474C58'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M23.3047 18H7.30469V19H8.38574C8.68955 20.3188 10.0815 21.3153 11.7527 21.3153C13.424 21.3153 14.8159 20.3188 15.1197 19H15.2432C15.547 20.3188 16.9389 21.3153 18.6102 21.3153C20.2814 21.3153 21.6733 20.3188 21.9772 19H23.3047V18Z'
            fill='#474C58'
          />
        </svg>
      )
    case 'logo':
      return (
        <svg
          className={`svg-icon svg-icon_logo ${classSvg}`}
          viewBox='0 0 499 101'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M115.04 39.9996C117.14 36.3996 120.04 33.4996 123.64 31.2996C127.34 29.0996 131.34 28.0996 135.64 28.0996C139.84 28.0996 143.74 29.0996 147.34 31.0996C150.94 33.0996 153.84 35.7996 155.94 39.1996L148.14 43.5996C146.84 41.4996 145.04 39.7996 142.84 38.5996C140.64 37.3996 138.24 36.6996 135.64 36.6996C131.54 36.6996 128.04 38.1996 125.14 41.1996C122.24 44.1996 120.84 47.7996 120.84 51.8996C120.84 55.9996 122.24 59.4996 125.14 62.4996C128.04 65.3996 131.54 66.8996 135.74 66.8996C138.44 66.8996 140.84 66.2996 143.04 64.9996C145.24 63.6996 147.04 61.9996 148.34 59.7996L156.04 64.2996C153.84 67.7996 151.04 70.4996 147.34 72.5996C143.74 74.5996 139.74 75.6996 135.54 75.6996C131.24 75.6996 127.24 74.5996 123.64 72.4996C119.94 70.3996 117.04 67.4996 114.94 63.8996C112.84 60.2996 111.74 56.2996 111.74 51.9996C111.74 47.6996 112.94 43.5996 115.04 39.9996Z' />
          <path d='M166.24 28.8996H175.44V34.3996C177.54 31.8996 179.84 30.1996 182.44 29.3996C184.94 28.5996 188.54 28.0996 193.24 28.0996V36.8996C189.64 36.8996 186.54 37.1996 184.14 37.8996C181.74 38.5996 179.94 39.5996 178.74 40.9996C177.54 42.3996 176.74 43.7996 176.24 45.2996C175.74 46.7996 175.54 48.6996 175.54 50.7996V74.3996H166.34V28.8996H166.24Z' />
          <path d='M199.641 40.0996C201.641 36.4996 204.341 33.5996 207.941 31.3996C211.541 29.1996 215.541 28.0996 219.941 28.0996C223.241 28.0996 226.341 28.6996 229.241 29.9996C232.141 31.2996 234.641 32.9996 236.641 35.1996C238.641 37.3996 240.241 39.8996 241.441 42.7996C242.641 45.6996 243.241 48.6996 243.241 51.8996C243.241 52.6996 243.141 53.7996 243.041 54.9996H205.741C206.441 58.5996 208.041 61.4996 210.741 63.8996C213.441 66.1996 216.641 67.3996 220.441 67.3996C222.941 67.3996 225.341 66.8996 227.641 65.7996C229.941 64.6996 231.741 63.1996 233.141 61.1996L239.641 66.1996C237.541 69.1996 234.741 71.4996 231.341 73.1996C227.941 74.8996 224.241 75.6996 220.341 75.6996C213.741 75.6996 208.041 73.3996 203.441 68.7996C198.841 64.1996 196.541 58.5996 196.541 51.8996C196.641 47.6996 197.641 43.6996 199.641 40.0996ZM233.841 47.6996C233.241 44.4996 231.741 41.7996 229.141 39.6996C226.641 37.5996 223.541 36.4996 220.041 36.4996C216.541 36.4996 213.641 37.4996 211.041 39.5996C208.541 41.6996 206.841 44.3996 206.041 47.6996H233.841Z' />
          <path d='M308.94 9.79961C310.04 8.69961 311.44 8.09961 313.14 8.09961C314.84 8.09961 316.24 8.69961 317.34 9.79961C318.44 10.8996 319.04 12.2996 319.04 13.9996C319.04 15.6996 318.44 17.0996 317.34 18.1996C316.24 19.2996 314.84 19.8996 313.14 19.8996C311.44 19.8996 310.04 19.2996 308.94 18.1996C307.84 17.0996 307.24 15.6996 307.24 13.9996C307.24 12.2996 307.84 10.8996 308.94 9.79961ZM308.44 28.8996H317.74V74.3996H308.44V28.8996Z' />
          <path d='M434.541 74.4V3.5H443.741V74.4H434.541Z' />
          <path d='M454.641 40.0996C456.641 36.4996 459.341 33.5996 462.941 31.3996C466.541 29.1996 470.541 28.0996 474.941 28.0996C478.241 28.0996 481.341 28.6996 484.241 29.9996C487.141 31.2996 489.641 32.9996 491.641 35.1996C493.641 37.3996 495.241 39.8996 496.441 42.7996C497.641 45.6996 498.241 48.6996 498.241 51.8996C498.241 52.6996 498.141 53.7996 498.041 54.9996H460.741C461.441 58.5996 463.041 61.4996 465.741 63.8996C468.441 66.1996 471.641 67.3996 475.441 67.3996C477.941 67.3996 480.341 66.8996 482.641 65.7996C484.941 64.6996 486.741 63.1996 488.141 61.1996L494.641 66.1996C492.541 69.1996 489.741 71.4996 486.341 73.1996C482.941 74.8996 479.241 75.6996 475.341 75.6996C468.741 75.6996 463.041 73.3996 458.441 68.7996C453.841 64.1996 451.541 58.5996 451.541 51.8996C451.641 47.6996 452.641 43.6996 454.641 40.0996ZM488.841 47.6996C488.241 44.4996 486.741 41.7996 484.141 39.6996C481.641 37.5996 478.541 36.4996 475.041 36.4996C471.541 36.4996 468.641 37.4996 466.041 39.5996C463.541 41.6996 461.841 44.3996 461.041 47.6996H488.841Z' />
          <path d='M352.74 74.4C365.84 74.4 376.54 63.8 376.54 50.6C376.54 37.5 365.84 26.8 352.74 26.8H340.04V3.5H330.84V50.6V72C330.84 73.3 331.84 74.3 333.14 74.3C338.64 74.3 351.94 74.4 352.74 74.4ZM352.74 35.5C361.04 35.5 367.84 42.3 367.84 50.6C367.84 58.9 361.04 65.7 352.74 65.7H342.34C341.04 65.7 340.04 64.7 340.04 63.4V35.5H352.74Z' />
          <path d='M404.439 74.4C417.539 74.4 428.239 63.8 428.239 50.6C428.239 37.5 417.539 26.8 404.439 26.8H391.739V3.5H382.539V50.6V72C382.539 73.3 383.539 74.3 384.839 74.3C390.339 74.3 403.639 74.4 404.439 74.4ZM404.439 35.5C412.739 35.5 419.539 42.3 419.539 50.6C419.539 58.9 412.739 65.7 404.439 65.7H394.039C392.739 65.7 391.739 64.7 391.739 63.4V35.5H404.439Z' />
          <path d='M294.24 74.3C295.24 74.3 296.04 73.5 296.04 72.5V50.6V3.5H286.84V26.8H274.14C261.04 26.8 250.34 37.4 250.34 50.6C250.34 63.7 261.04 74.4 274.14 74.4C275.04 74.4 289.14 74.3 294.24 74.3ZM286.84 35.5V63.9C286.84 64.9 286.04 65.7 285.04 65.7H274.14C265.84 65.7 259.04 58.9 259.04 50.6C259.04 42.3 265.84 35.5 274.14 35.5H286.84Z' />
          <path d='M50.5397 101C45.7397 101 40.9397 100.3 36.0397 99C19.8397 94.5 6.83966 81.6 2.13966 65.5C-2.46034 49.6 0.439658 33.1 10.0397 20.2C19.6397 7.3 34.4397 0 50.4397 0C68.2397 0 84.4397 9.1 93.7397 24.4C97.0397 29.8 96.1396 36.7 91.6396 41.1L82.2397 50.5L91.6396 59.9C96.1396 64.4 96.9397 71.3 93.7397 76.6C84.4397 92.1 68.1397 101 50.5397 101ZM50.6396 11.2C38.1396 11.2 26.6397 16.9 19.1397 26.9C11.6397 36.9 9.33966 49.8 13.0397 62.3C16.6397 74.7 26.6397 84.6 39.1397 88.1C56.8397 93.1 74.9397 86.1 84.2397 70.7C84.8397 69.8 84.6397 68.5 83.8397 67.7L74.4397 58.3L66.5397 66.2C62.3397 70.4 56.6396 72.8 50.6396 72.8C44.6396 72.8 39.0397 70.5 34.7397 66.2C30.5397 62 28.1397 56.3 28.1397 50.3C28.1397 44.3 30.4397 38.7 34.7397 34.4L49.3397 19.8C50.0397 19.1 51.2397 19.1 51.9397 19.8L74.4397 42.3L83.8397 32.9C84.6397 32.1 84.8397 30.8 84.2397 29.9C77.0397 18.3 64.4397 11.2 50.6396 11.2ZM51.9397 35.9C51.2397 35.2 50.0397 35.2 49.3397 35.9L42.7397 42.5C40.6397 44.6 39.4397 47.4 39.4397 50.4C39.4397 53.4 40.6397 56.2 42.7397 58.3C44.8397 60.4 47.6396 61.6 50.6396 61.6C53.6396 61.6 56.4397 60.4 58.5397 58.3L66.4397 50.4L51.9397 35.9Z' />
          <path
            opacity='0.25'
            d='M92.2395 40.6002L82.3395 50.5002L74.4395 42.6002L84.3395 32.7002L92.2395 40.6002Z'
            fill='url(#paint0_linear)'
          />
          <path
            opacity='0.25'
            d='M57.6406 59.4L66.4406 50.5L74.4406 58.4L65.5406 67.3L57.6406 59.4Z'
            fill='url(#paint1_linear)'
          />
          <path d='M115.04 39.9996C117.14 36.3996 120.04 33.4996 123.64 31.2996C127.34 29.0996 131.34 28.0996 135.64 28.0996C139.84 28.0996 143.74 29.0996 147.34 31.0996C150.94 33.0996 153.84 35.7996 155.94 39.1996L148.14 43.5996C146.84 41.4996 145.04 39.7996 142.84 38.5996C140.64 37.3996 138.24 36.6996 135.64 36.6996C131.54 36.6996 128.04 38.1996 125.14 41.1996C122.24 44.1996 120.84 47.7996 120.84 51.8996C120.84 55.9996 122.24 59.4996 125.14 62.4996C128.04 65.3996 131.54 66.8996 135.74 66.8996C138.44 66.8996 140.84 66.2996 143.04 64.9996C145.24 63.6996 147.04 61.9996 148.34 59.7996L156.04 64.2996C153.84 67.7996 151.04 70.4996 147.34 72.5996C143.74 74.5996 139.74 75.6996 135.54 75.6996C131.24 75.6996 127.24 74.5996 123.64 72.4996C119.94 70.3996 117.04 67.4996 114.94 63.8996C112.84 60.2996 111.74 56.2996 111.74 51.9996C111.74 47.6996 112.94 43.5996 115.04 39.9996Z' />
          <path d='M166.24 28.8996H175.44V34.3996C177.54 31.8996 179.84 30.1996 182.44 29.3996C184.94 28.5996 188.54 28.0996 193.24 28.0996V36.8996C189.64 36.8996 186.54 37.1996 184.14 37.8996C181.74 38.5996 179.94 39.5996 178.74 40.9996C177.54 42.3996 176.74 43.7996 176.24 45.2996C175.74 46.7996 175.54 48.6996 175.54 50.7996V74.3996H166.34V28.8996H166.24Z' />
          <path d='M199.641 40.0996C201.641 36.4996 204.341 33.5996 207.941 31.3996C211.541 29.1996 215.541 28.0996 219.941 28.0996C223.241 28.0996 226.341 28.6996 229.241 29.9996C232.141 31.2996 234.641 32.9996 236.641 35.1996C238.641 37.3996 240.241 39.8996 241.441 42.7996C242.641 45.6996 243.241 48.6996 243.241 51.8996C243.241 52.6996 243.141 53.7996 243.041 54.9996H205.741C206.441 58.5996 208.041 61.4996 210.741 63.8996C213.441 66.1996 216.641 67.3996 220.441 67.3996C222.941 67.3996 225.341 66.8996 227.641 65.7996C229.941 64.6996 231.741 63.1996 233.141 61.1996L239.641 66.1996C237.541 69.1996 234.741 71.4996 231.341 73.1996C227.941 74.8996 224.241 75.6996 220.341 75.6996C213.741 75.6996 208.041 73.3996 203.441 68.7996C198.841 64.1996 196.541 58.5996 196.541 51.8996C196.641 47.6996 197.641 43.6996 199.641 40.0996ZM233.841 47.6996C233.241 44.4996 231.741 41.7996 229.141 39.6996C226.641 37.5996 223.541 36.4996 220.041 36.4996C216.541 36.4996 213.641 37.4996 211.041 39.5996C208.541 41.6996 206.841 44.3996 206.041 47.6996H233.841Z' />
          <path d='M308.94 9.79961C310.04 8.69961 311.44 8.09961 313.14 8.09961C314.84 8.09961 316.24 8.69961 317.34 9.79961C318.44 10.8996 319.04 12.2996 319.04 13.9996C319.04 15.6996 318.44 17.0996 317.34 18.1996C316.24 19.2996 314.84 19.8996 313.14 19.8996C311.44 19.8996 310.04 19.2996 308.94 18.1996C307.84 17.0996 307.24 15.6996 307.24 13.9996C307.24 12.2996 307.84 10.8996 308.94 9.79961ZM308.44 28.8996H317.74V74.3996H308.44V28.8996Z' />
          <path d='M434.541 74.4V3.5H443.741V74.4H434.541Z' />
          <path d='M454.641 40.0996C456.641 36.4996 459.341 33.5996 462.941 31.3996C466.541 29.1996 470.541 28.0996 474.941 28.0996C478.241 28.0996 481.341 28.6996 484.241 29.9996C487.141 31.2996 489.641 32.9996 491.641 35.1996C493.641 37.3996 495.241 39.8996 496.441 42.7996C497.641 45.6996 498.241 48.6996 498.241 51.8996C498.241 52.6996 498.141 53.7996 498.041 54.9996H460.741C461.441 58.5996 463.041 61.4996 465.741 63.8996C468.441 66.1996 471.641 67.3996 475.441 67.3996C477.941 67.3996 480.341 66.8996 482.641 65.7996C484.941 64.6996 486.741 63.1996 488.141 61.1996L494.641 66.1996C492.541 69.1996 489.741 71.4996 486.341 73.1996C482.941 74.8996 479.241 75.6996 475.341 75.6996C468.741 75.6996 463.041 73.3996 458.441 68.7996C453.841 64.1996 451.541 58.5996 451.541 51.8996C451.641 47.6996 452.641 43.6996 454.641 40.0996ZM488.841 47.6996C488.241 44.4996 486.741 41.7996 484.141 39.6996C481.641 37.5996 478.541 36.4996 475.041 36.4996C471.541 36.4996 468.641 37.4996 466.041 39.5996C463.541 41.6996 461.841 44.3996 461.041 47.6996H488.841Z' />
          <path d='M352.74 74.4C365.84 74.4 376.54 63.8 376.54 50.6C376.54 37.5 365.84 26.8 352.74 26.8H340.04V3.5H330.84V50.6V72C330.84 73.3 331.84 74.3 333.14 74.3C338.64 74.3 351.94 74.4 352.74 74.4ZM352.74 35.5C361.04 35.5 367.84 42.3 367.84 50.6C367.84 58.9 361.04 65.7 352.74 65.7H342.34C341.04 65.7 340.04 64.7 340.04 63.4V35.5H352.74Z' />
          <path d='M404.439 74.4C417.539 74.4 428.239 63.8 428.239 50.6C428.239 37.5 417.539 26.8 404.439 26.8H391.739V3.5H382.539V50.6V72C382.539 73.3 383.539 74.3 384.839 74.3C390.339 74.3 403.639 74.4 404.439 74.4ZM404.439 35.5C412.739 35.5 419.539 42.3 419.539 50.6C419.539 58.9 412.739 65.7 404.439 65.7H394.039C392.739 65.7 391.739 64.7 391.739 63.4V35.5H404.439Z' />
          <path d='M294.24 74.3C295.24 74.3 296.04 73.5 296.04 72.5V50.6V3.5H286.84V26.8H274.14C261.04 26.8 250.34 37.4 250.34 50.6C250.34 63.7 261.04 74.4 274.14 74.4C275.04 74.4 289.14 74.3 294.24 74.3ZM286.84 35.5V63.9C286.84 64.9 286.04 65.7 285.04 65.7H274.14C265.84 65.7 259.04 58.9 259.04 50.6C259.04 42.3 265.84 35.5 274.14 35.5H286.84Z' />
          <defs>
            <linearGradient
              id='paint0_linear'
              x1='78.3943'
              y1='46.4923'
              x2='88.3009'
              y2='36.5857'
              gradientUnits='userSpaceOnUse'
            >
              <stop />
              <stop offset='1' stopOpacity='0' />
            </linearGradient>
            <linearGradient
              id='paint1_linear'
              x1='70.3962'
              y1='54.4779'
              x2='61.5416'
              y2='63.3326'
              gradientUnits='userSpaceOnUse'
            >
              <stop />
              <stop offset='1' stopOpacity='0' />
            </linearGradient>
          </defs>
        </svg>
      )
    case 'info':
      return (
        <svg
          className={`svg-icon svg-icon_info ${classSvg}`}
          viewBox='0 0 22 22'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle cx='10' cy='10' r='9' />

          <path d='M10 15V8.75' />

          <path d='M10 7.5V5' />
        </svg>
      )
    case 'star':
      return (
        <svg
          className={`svg-icon svg-icon_star ${classSvg}`}
          width='16'
          height='15'
          viewBox='0 0 16 15'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M8 0L9.79611 5.52786H15.6085L10.9062 8.94427L12.7023 14.4721L8 11.0557L3.29772 14.4721L5.09383 8.94427L0.391548 5.52786H6.20389L8 0Z'
            fill='#4286F5'
          />
        </svg>
      )
    case 'heart':
      return (
        <svg
          className={`svg-icon svg-icon_heart ${classSvg}`}
          viewBox='0 0 32 32'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M16.065 11.5913C16.0868 11.6131 16.1083 11.6351 16.1294 11.6573L16.1835 11.7113C17.7381 10.2182 20.1917 10.2202 21.7018 11.7303C23.2312 13.2597 23.2137 15.7569 21.6627 17.3078C21.6401 17.3305 21.6172 17.3528 21.5942 17.3748L15.9845 22.9845L10.3281 17.3281L10.3289 17.3274C8.76696 15.7654 8.78483 13.2152 10.3688 11.6312C11.9528 10.0472 14.5031 10.0294 16.065 11.5913Z'
          />
        </svg>
      )
    case 'eye':
      return (
        <svg
          className={`svg-icon svg-icon_eye  ${classSvg}`}
          viewBox='0 0 24 24'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12 7C12.6947 7 13.5576 7.26741 14.5562 7.83358C15.5382 8.39033 16.5185 9.16021 17.4102 9.97579C18.1945 10.6931 18.8775 11.4156 19.3962 12C18.8775 12.5844 18.1945 13.3069 17.4102 14.0242C16.5185 14.8398 15.5382 15.6097 14.5562 16.1664C13.5576 16.7326 12.6947 17 12 17C11.3053 17 10.4424 16.7326 9.44382 16.1664C8.46181 15.6097 7.48146 14.8398 6.58976 14.0242C5.80555 13.3069 5.1225 12.5844 4.60378 12C5.1225 11.4156 5.80555 10.6931 6.58976 9.97579C7.48146 9.16021 8.46181 8.39033 9.44382 7.83358C10.4424 7.26741 11.3053 7 12 7ZM12 19C7.30648 19 2 12 2 12C2 12 7.30648 5 12 5C16.6935 5 22 12 22 12C22 12 16.6935 19 12 19ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z'
          />
        </svg>
      )
    case 'more':
      return (
        <svg
          className={`svg-icon svg-icon_more ${classSvg}`}
          viewBox='0 0 20 4'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M4 2C4 3.10457 3.10457 4 2 4C0.895431 4 0 3.10457 0 2C0 0.895431 0.895431 0 2 0C3.10457 0 4 0.895431 4 2ZM12 2C12 3.10457 11.1046 4 10 4C8.89543 4 8 3.10457 8 2C8 0.895431 8.89543 0 10 0C11.1046 0 12 0.895431 12 2ZM18 4C19.1046 4 20 3.10457 20 2C20 0.895431 19.1046 0 18 0C16.8954 0 16 0.895431 16 2C16 3.10457 16.8954 4 18 4Z' />
        </svg>
      )
    case 'arrow-up':
      return (
        <svg
          className={`svg-icon svg-icon_arrow-up ${classSvg}`}
          viewBox='0 0 12 12'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M6.49665 0.443333L5.99821 0L5.49976 0.443333L0 5.33502L0.996888 6.45583L5.24851 2.67429V11.9998H6.74851V2.67482L10.9995 6.45583L11.9964 5.33502L6.49665 0.443333Z' />
        </svg>
      )
    case 'equifax':
      return (
        <svg
          className={`svg-icon svg-icon_equifax ${classSvg}`}
          viewBox='0 0 80 16'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M12.69 2.542l.504-2.407h-10.466l-1.387 6.62-1.177 5.331h10.761l.546-2.536h-5.969l.546-2.58h5.044l.546-2.407h-5.044l.42-2.021h5.675zM21.476 6.969h3.657c.129-.777.37-1.936.42-2.88.058-1.105-.368-1.918-1.303-2.451-1.34-.759-3.313-.719-4.792-.774-2.027-.075-4.44.192-5.717 2.02-.659.943-1.029 2.404-1.175 3.547-.18 1.394-.868 3.734.376 4.879.925.853 2.995 1.137 4.198 1.12 1.226-.018 2.415-.1 3.62-.345l3.152 3.911h4.918l-7.356-9.027zm-.547.086c-.402 1.853-.95 3.413-3.069 3.396-2.127-.016-1.421-2.342-1.219-3.696.286-1.925 1.014-3.944 3.195-3.783 2.207.163 1.428 2.543 1.093 4.084zM41.106 1.467l-1.135 5.288-1.135 5.331h4.287l2.312-10.619h-4.329zM55.944 3.573l.504-2.106h-9.374l-2.27 10.619h4.33l.966-4.557h4.245l.168-.774.252-1.204h-4.203l.42-1.978h4.96zM27.319 1.467h4.372l-1.639 7.523c-.2.92.644 1.399 1.368 1.463.931.083 1.766-.512 1.995-1.506l1.723-7.48h4.329l-1.723 7.953c-.738 2.073-2.447 2.888-4.334 3.091-1.17.127-2.409.019-3.526-.168l-3.867-4.729 1.303-6.147zM65.653 1.467h5.506l1.681 2.752 2.732-2.752h4.203l-5.506 4.944 3.615 5.675h-5.38l-1.765-3.225-3.026 3.225h-6.431l-.252-2.322h-4.456l-1.555 2.322h-3.026l7.314-10.619h5.254l1.009 8.598 3.489-3.267-3.405-5.331zm-7.65 6.018l2.354-3.611.421 3.611h-2.774z' />
        </svg>
      )
    case 'progress-bar-tick':
      return (
        <svg
          className={`svg-icon svg-icon_progress-bar-tick ${classSvg}`}
          viewBox='0 0 32 32'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M29.3332 8.34682L12.7403 26.6673L2.6665 16.7643L5.92548 13.5605L12.5458 20.0686L25.8909 5.33398L29.3332 8.34682Z'
          />
        </svg>
      )
    case 'payment-status-success':
      return (
        <svg
          className={`svg-icon svg-icon_payment-status-success ${classSvg}`}
          viewBox='0 0 20 20'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle cx='10' cy='10' r='10' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15 7.12981L8.77768 14L5 10.2864L6.22212 9.08496L8.70473 11.5255L13.7092 6L15 7.12981Z'
          />
        </svg>
      )

    case 'payment-status-ZERO':
      return (
        // <svg
        //   className={`svg-icon svg-icon_payment-status-ZERO ${classSvg}`}
        //   xmlns="http://www.w3.org/2000/svg"
        //   x="0px"
        //   y="0px"
        //   viewBox="-295 133 20 20"
        // >
        //   <circle cx="-285" cy="143" r="10" />
        //   <text transform="matrix(1 0 0 1 -289 147.125)" class="text">
        //     0
        //   </text>
        // </svg>
        <svg
          className={`svg-icon svg-icon_payment-status-success ${classSvg}`}
          viewBox='0 0 20 20'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle cx='10' cy='10' r='10' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15 7.12981L8.77768 14L5 10.2864L6.22212 9.08496L8.70473 11.5255L13.7092 6L15 7.12981Z'
          />
        </svg>
      )

    case 'payment-status-ONE':
      return (
        <svg
          className={`svg-icon svg-icon_payment-status-ONE ${classSvg} ${additional}`}
          xmlns='http://www.w3.org/2000/svg'
          x='0px'
          y='0px'
          viewBox='-295 133 20 20'
        >
          <circle cx='-285' cy='143' r='10' />
          <text transform='matrix(1 0 0 1 -288 147.125)' class='text'>
            1
          </text>
        </svg>
      )
    case 'payment-status-TWO':
      return (
        <svg
          className={`svg-icon svg-icon_payment-status-TWO ${classSvg} ${additional}`}
          xmlns='http://www.w3.org/2000/svg'
          x='0px'
          y='0px'
          viewBox='-295 133 20 20'
        >
          <circle cx='-285' cy='143' r='10' />
          <text transform='matrix(1 0 0 1 -288 147.125)' class='text'>
            2
          </text>
        </svg>
      )
    case 'payment-status-THREE':
      return (
        <svg
          className={`svg-icon svg-icon_payment-status-THREE ${classSvg} ${additional}`}
          xmlns='http://www.w3.org/2000/svg'
          x='0px'
          y='0px'
          viewBox='-295 133 20 20'
        >
          <circle cx='-285' cy='143' r='10' />
          <text transform='matrix(1 0 0 1 -288 147.125)' class='text'>
            3
          </text>
        </svg>
      )
    case 'payment-status-I':
      return (
        <svg
          className={`svg-icon svg-icon_payment-status-warning ${classSvg}`}
          viewBox='0 0 20 20'
        >
          <circle cx='10' cy='10' r='10' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15 7.12981L8.77768 14L5 10.2864L6.22212 9.08496L8.70473 11.5255L13.7092 6L15 7.12981Z'
          />
        </svg>
      )
    case 'payment-status-FOUR':
      return (
        <svg
          className={`svg-icon svg-icon_payment-status-FOUR ${classSvg} ${additional}`}
          xmlns='http://www.w3.org/2000/svg'
          x='0px'
          y='0px'
          viewBox='-295 133 20 20'
        >
          <circle cx='-285' cy='143' r='10' />
          <text transform='matrix(1 0 0 1 -288 147.125)' class='text'>
            4
          </text>
        </svg>
      )
    case 'payment-status-FIVE':
      return (
        <svg
          className={`svg-icon svg-icon_payment-status-FIVE ${classSvg} ${additional}`}
          xmlns='http://www.w3.org/2000/svg'
          x='0px'
          y='0px'
          viewBox='-295 133 20 20'
        >
          <circle cx='-285' cy='143' r='10' />
          <text transform='matrix(1 0 0 1 -288 147.125)' class='text'>
            5
          </text>
        </svg>
      )
    case 'payment-status-SIX':
      return (
        <svg
          className={`svg-icon svg-icon_payment-status-SIX ${classSvg} ${additional}`}
          xmlns='http://www.w3.org/2000/svg'
          x='0px'
          y='0px'
          viewBox='-295 133 20 20'
        >
          <circle cx='-285' cy='143' r='10' />
          <text transform='matrix(1 0 0 1 -288 147.125)' class='text'>
            6
          </text>
        </svg>
      )
    case 'payment-status-D':
      return (
        <svg
          className={`svg-icon svg-icon_payment-status-d ${classSvg}`}
          viewBox='0 0 20 20'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle cx='10' cy='10' r='10' />
          <path d='M9.42781 6C10.123 6 10.7398 6.16117 11.2781 6.48352C11.82 6.8022 12.2424 7.25275 12.5455 7.83516C12.8485 8.41392 13 9.07692 13 9.82418V10.1758C13 10.9267 12.8485 11.5916 12.5455 12.1703C12.2424 12.7491 11.82 13.1996 11.2781 13.522C10.7362 13.8407 10.1159 14 9.41711 14H7.72727H7V6H8.67914H9.42781ZM11.2941 9.81319C11.2941 9.02198 11.1355 8.42125 10.8182 8.01099C10.5009 7.60073 10.0374 7.3956 9.42781 7.3956H8.67914V12.6099H9.41711C10.0267 12.6099 10.492 12.4029 10.8128 11.989C11.1337 11.5714 11.2941 10.967 11.2941 10.1758V9.81319Z' />
        </svg>
      )
    case 'payment-status-S':
      return (
        <svg
          className={`svg-icon svg-icon_payment-status-sd ${classSvg}`}
          viewBox='0 0 20 20'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle cx='10' cy='10' r='10' />
          <path
            d='M10.0577 10.6471C9.49271 10.4759 9.006 10.287 8.59755 10.0802C8.19291 9.86988 7.86844 9.60784 7.62413 9.29412C7.37982 8.98039 7.25767 8.60784 7.25767 8.17647C7.25767 7.7451 7.38937 7.36542 7.65276 7.03743C7.91997 6.70588 8.28834 6.45098 8.75787 6.27273C9.2274 6.09091 9.76374 6 10.3669 6C10.9738 6 11.5102 6.1016 11.9759 6.30481C12.4416 6.50446 12.8023 6.78788 13.0581 7.15508C13.3138 7.51872 13.4417 7.93583 13.4417 8.40642H11.6495C11.6495 8.07843 11.5369 7.81818 11.3117 7.62567C11.0902 7.42959 10.7639 7.33155 10.3325 7.33155C10.0577 7.33155 9.8229 7.36898 9.62822 7.44385C9.43736 7.51872 9.2923 7.6221 9.19305 7.75401C9.09761 7.88235 9.0499 8.02674 9.0499 8.18717C9.0499 8.42603 9.1816 8.62923 9.44499 8.79679C9.70838 8.96078 10.1168 9.12299 10.6704 9.28342C11.6056 9.5508 12.3003 9.88592 12.7546 10.2888C13.2127 10.6881 13.4417 11.2014 13.4417 11.8289C13.4417 12.2816 13.3177 12.672 13.0695 13C12.8214 13.3244 12.4683 13.5722 12.0102 13.7433C11.556 13.9144 11.0215 14 10.4069 14C9.81909 14 9.26558 13.9055 8.74642 13.7166C8.23108 13.5276 7.81118 13.2389 7.48671 12.8503C7.16224 12.4581 7 11.9786 7 11.4118H8.80368C8.80368 11.8574 8.9411 12.18 9.21595 12.3797C9.49461 12.5758 9.89162 12.6738 10.4069 12.6738C10.8154 12.6738 11.1227 12.5971 11.3288 12.4439C11.5388 12.2906 11.6438 12.0891 11.6438 11.8396C11.6438 11.6542 11.6018 11.4991 11.5178 11.3743C11.4338 11.2496 11.2792 11.1301 11.054 11.016C10.8288 10.902 10.4967 10.779 10.0577 10.6471Z'
            fill='white'
          />
        </svg>
      )
    case 'payment-status-Z':
      return (
        <svg
          className={`svg-icon svg-icon_payment-status-z ${classSvg}`}
          viewBox='0 0 20 20'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle cx='10' cy='10' r='10' />
          <path d='M13 12.6099V14H7.43548H7.00538V13.011L10.828 7.3956H7V6H12.3548H12.9301V6.96154L9.12903 12.6099H13Z' />
        </svg>
      )
    case 'payment-status-U':
      return (
        <svg
          className={`svg-icon svg-icon_payment-status-z ${classSvg}`}
          viewBox='0 0 20 20'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle cx='10' cy='10' r='10' />
          <path d='M13 12.6099V14H7.43548H7.00538V13.011L10.828 7.3956H7V6H12.3548H12.9301V6.96154L9.12903 12.6099H13Z' />
        </svg>
      )
    case 'payment-status-N':
      return (
        <svg
          className={`svg-icon svg-icon_payment-status-z ${classSvg}`}
          viewBox='0 0 20 20'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle cx='10' cy='10' r='10' fill='#A1A6AE' />
          <path
            d='M13.6992 14H11.9414L8.51953 8.38672V14H6.76172V5.46875H8.51953L11.9473 11.0938V5.46875H13.6992V14Z'
            fill='white'
          />
        </svg>
      )
    case 'payment-status-DOT':
      return (
        <svg
          className={`svg-icon svg-icon_payment-status-z ${classSvg}`}
          viewBox='0 0 20 20'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle cx='10' cy='10' r='10' />
          <path d='M13 12.6099V14H7.43548H7.00538V13.011L10.828 7.3956H7V6H12.3548H12.9301V6.96154L9.12903 12.6099H13Z' />
        </svg>
      )
    case 'payment-status-cancel':
      return (
        <svg
          className={`svg-icon svg-icon_payment-status-cancel ${classSvg}`}
          viewBox='0 0 20 20'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle cx='10' cy='10' r='10' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M8.6666 9.99966L6 12.6661L7.33331 13.9993L9.99991 11.3329L12.6672 14L14.0005 12.6668L11.3332 9.99966L13.9999 7.33321L12.6665 6L9.99991 8.66645L7.33398 6.00071L6.00067 7.33393L8.6666 9.99966Z'
          />
        </svg>
      )
    case 'close':
      return (
        <svg
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <rect
            x='5.63574'
            y='4.2218'
            width='20'
            height='2'
            rx='1'
            transform='rotate(45 5.63574 4.2218)'
            fill='#474C58'
          />
          <rect
            x='4.22168'
            y='18.364'
            width='20'
            height='2'
            rx='1'
            transform='rotate(-45 4.22168 18.364)'
            fill='#474C58'
          />
        </svg>
      )
    case 'time':
      return (
        <svg
          width='18'
          height='19'
          viewBox='0 0 18 19'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M3.11329 5.28833C3.03592 5.2109 2.97456 5.119 2.93271 5.01786C2.89086 4.91672 2.86934 4.80832 2.86937 4.69887C2.86941 4.58941 2.89101 4.48103 2.93293 4.37992C2.97486 4.27881 3.03628 4.18695 3.11371 4.10958C3.19113 4.03221 3.28304 3.97084 3.38418 3.92899C3.48532 3.88714 3.59371 3.86562 3.70317 3.86566C3.81263 3.8657 3.92101 3.8873 4.02212 3.92922C4.12323 3.97114 4.21509 4.03257 4.29246 4.10999L9.89496 8.59166L10.185 8.82416C10.4975 9.13678 10.673 9.56075 10.6729 10.0028C10.6728 10.4448 10.4972 10.8687 10.1845 11.1812C10.0297 11.336 9.84599 11.4587 9.64376 11.5424C9.44153 11.6262 9.22479 11.6692 9.00592 11.6692C8.56388 11.6691 8.13997 11.4935 7.82746 11.1808L7.59579 10.8908L3.11329 5.28833ZM8.99996 16.665C10.3185 16.6652 11.6075 16.2744 12.704 15.542C13.8004 14.8097 14.6551 13.7686 15.1598 12.5505C15.6646 11.3324 15.7968 9.99198 15.5398 8.69873C15.2828 7.40548 14.648 6.21749 13.7158 5.28499L14.8941 4.10666C15.6687 4.87966 16.2829 5.79807 16.7015 6.80915C17.1201 7.82022 17.3348 8.90403 17.3333 9.99833C17.3333 14.6008 13.6025 18.3317 8.99996 18.3317C4.39746 18.3317 0.666626 14.6017 0.666626 9.99999H2.33329C2.33373 11.7678 3.03631 13.4631 4.2865 14.713C5.5367 15.9628 7.23214 16.665 8.99996 16.665ZM8.99996 0.833328C9.44199 0.833328 9.86591 1.00892 10.1785 1.32148C10.491 1.63404 10.6666 2.05797 10.6666 2.49999C10.6666 2.94202 10.491 3.36595 10.1785 3.67851C9.86591 3.99107 9.44199 4.16666 8.99996 4.16666C8.55793 4.16666 8.13401 3.99107 7.82145 3.67851C7.50889 3.36595 7.33329 2.94202 7.33329 2.49999C7.33329 2.05797 7.50889 1.63404 7.82145 1.32148C8.13401 1.00892 8.55793 0.833328 8.99996 0.833328Z'
            fill='#c4c4c4'
          />
        </svg>
      )
    case 'sort':
      return (
        <svg
          width='21'
          height='12'
          viewBox='0 0 21 12'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <rect
            x='0.431885'
            y='0.0927734'
            width='19.7918'
            height='1.96809'
            rx='0.984047'
            fill='#4286F5'
          />
          <rect
            x='5.41235'
            y='4.9668'
            width='9.83241'
            height='1.96809'
            rx='0.984047'
            fill='#4286F5'
          />
          <rect
            x='8.81079'
            y='9.84863'
            width='3.0293'
            height='1.96809'
            rx='0.984047'
            fill='#4286F5'
          />
        </svg>
      )

    // this is for ESSENTIAL ^_^
    case 'today':
      return (
        <svg
          className={classSvg}
          width='28'
          height='28'
          viewBox='0 0 28 28'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M0 0H28V28H0V0Z' fill='white' />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M5 5C4.44772 5 4 5.44772 4 6V9H24V6C24 5.44772 23.5523 5 23 5H21V3H23C24.6569 3 26 4.34315 26 6V11H2V6C2 4.34315 3.34315 3 5 3H7V5H5ZM17 5H11V3H17V5Z'
            fill='#A3CEF1'
          />
          <path d='M9 2V6' stroke='#4286F5' stroke-width='2' />
          <path d='M19 2V6' stroke='#4286F5' stroke-width='2' />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M26 12H2V24C2 25.1046 2.89543 26 4 26H24C25.1046 26 26 25.1046 26 24V12ZM13.0001 22.9142L19.2072 16.7071L17.793 15.2929L13.0001 20.0858L10.7072 17.7929L9.29297 19.2071L13.0001 22.9142Z'
            fill='#4286F5'
          />
        </svg>
      )
    case 'history':
      return (
        <svg
          className={classSvg}
          width='28'
          height='28'
          viewBox='0 0 28 28'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M0 0H28V28H0V0Z' fill='white' />
          <path
            d='M7.41151 21.5885C8.14387 22.3208 8.97132 22.9395 9.8661 23.4313M1.5 14.9778L4.22222 17.8485V13.8889C4.22222 11.3697 5.09572 8.92843 6.69389 6.98106C8.29205 5.0337 10.516 3.70072 12.9868 3.20924C15.4576 2.71777 18.0224 3.09822 20.2441 4.28576C22.4658 5.4733 24.2071 7.39446 25.1711 9.7219C26.1352 12.0493 26.2624 14.639 25.5311 17.0498C24.7998 19.4605 23.2553 21.5431 21.1607 22.9427C19.066 24.3422 16.5509 24.9723 14.0438 24.7253C12.9012 24.6128 11.7925 24.3213 10.7556 23.8687'
            stroke='#A3CEF1'
            stroke-width='2'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M15.111 21.5111C19.3206 21.5111 22.7332 18.0985 22.7332 13.8889C22.7332 9.67925 19.3206 6.26666 15.111 6.26666C10.9014 6.26666 7.48877 9.67925 7.48877 13.8889C7.48877 18.0985 10.9014 21.5111 15.111 21.5111ZM16.1111 9.53334H14.1111V14.8889H19.4666V12.8889H16.1111V9.53334Z'
            fill='#4286F5'
          />
        </svg>
      )

    // this is for LENDER SCORE ICON ^_^
    case 'credit-credit':
      return (
        <svg
          className={classSvg}
          width='28'
          height='28'
          viewBox='0 0 28 28'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M0 0H28V28H0V0Z' fill='white' />
          <path
            d='M23.1153 12.9615V17.1538C23.1153 18.2584 22.2199 19.1538 21.1153 19.1538H3.88452C2.77995 19.1538 1.88452 18.2584 1.88452 17.1538V15.6154M23.1153 7.65385V7C23.1153 5.89543 22.2199 5 21.1153 5H3.88452C2.77995 5 1.88452 5.89543 1.88452 7V7.65385M1.88452 12.9615V14.7308'
            stroke='#A3CEF1'
            stroke-width='2'
          />
          <rect x='1' y='8.53847' width='23' height='3.53846' fill='#4286F5' />
          <rect
            x='4'
            y='12.9615'
            width='8.84615'
            height='1.76923'
            fill='#4286F5'
          />
          <path
            d='M25 8V8C25.5523 8 26 8.44772 26 9V20C26 21.1046 25.1046 22 24 22H5.88452C5.33224 22 4.88452 21.5523 4.88452 21V21'
            stroke='#A3CEF1'
            stroke-width='2'
          />
        </svg>
      )
    case 'short-term-credit':
      return (
        <svg
          className={classSvg}
          width='28'
          height='28'
          viewBox='0 0 28 28'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M0 0H28V28H0V0Z' fill='white' />
          <path
            d='M1 19.5H2.44444C3.16667 18.7778 5.04444 17.3333 6.77778 17.3333C8.94444 17.3333 9.66667 18.0556 11.8333 18.0556C12.8378 18.0556 14.0524 18.0556 15.0837 18.0556C16.0809 18.0556 16.8889 18.8639 16.8889 19.8611V19.8611C16.8889 20.8583 16.0805 21.6667 15.0833 21.6667H10.3889M1 26H15.6462C16.4419 26 17.205 25.6839 17.7676 25.1213L25.5858 17.3031C26.3668 16.5221 26.3668 15.2557 25.5858 14.4747L25.5253 14.4142C24.7443 13.6332 23.4779 13.6332 22.6969 14.4142L20.6111 16.5M18.6111 18.5L19.9861 17.125'
            stroke='#A3CEF1'
            stroke-width='2'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M14.5 15C18.0899 15 21 12.0899 21 8.5C21 4.91015 18.0899 2 14.5 2C10.9101 2 8 4.91015 8 8.5C8 12.0899 10.9101 15 14.5 15ZM16.9953 12L17 10.8726H13.7299C13.9321 10.5799 14.0332 10.1897 14.0332 9.7019L14 8.76965H15.4408V7.66396H13.9668L13.9242 6.36856C13.9242 6.1084 13.9621 5.88437 14.0379 5.69648C14.1137 5.50858 14.218 5.36766 14.3507 5.27371C14.4866 5.17615 14.6382 5.12737 14.8057 5.12737C15.0742 5.12737 15.2954 5.21409 15.4692 5.38753C15.643 5.55736 15.7299 5.82656 15.7299 6.19512H16.9194C16.9194 5.7579 16.8373 5.37489 16.673 5.04607C16.5118 4.71364 16.2749 4.45709 15.9621 4.27642C15.6524 4.09214 15.2812 4 14.8483 4C14.4281 4 14.0553 4.09395 13.7299 4.28184C13.4044 4.46974 13.1501 4.74255 12.9668 5.10027C12.7867 5.45799 12.6967 5.88076 12.6967 6.36856L12.7346 7.66396H12V8.76965H12.7678L12.7962 9.75068C12.7962 10.0253 12.7678 10.271 12.7109 10.4878C12.654 10.7046 12.5545 10.8329 12.4123 10.8726H12.019V12H16.9953Z'
            fill='#4286F5'
          />
        </svg>
      )
    case 'payment-history':
      return (
        <svg
          className={classSvg}
          width='28'
          height='28'
          viewBox='0 0 28 28'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M0 0H28V28H0V0Z' fill='white' />
          <path
            d='M7.41151 21.5885C8.14387 22.3208 8.97132 22.9395 9.8661 23.4313M1.5 14.9778L4.22222 17.8485V13.8889C4.22222 11.3697 5.09572 8.92843 6.69389 6.98106C8.29205 5.0337 10.516 3.70072 12.9868 3.20924C15.4576 2.71777 18.0224 3.09822 20.2441 4.28576C22.4658 5.4733 24.2071 7.39446 25.1711 9.7219C26.1352 12.0493 26.2624 14.639 25.5311 17.0498C24.7998 19.4605 23.2553 21.5431 21.1607 22.9427C19.066 24.3422 16.5509 24.9723 14.0438 24.7253C12.9012 24.6128 11.7925 24.3213 10.7556 23.8687'
            stroke='#A3CEF1'
            stroke-width='2'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M15.111 21.5111C19.3206 21.5111 22.7332 18.0985 22.7332 13.8889C22.7332 9.67925 19.3206 6.26666 15.111 6.26666C10.9014 6.26666 7.48877 9.67925 7.48877 13.8889C7.48877 18.0985 10.9014 21.5111 15.111 21.5111ZM16.1111 9.53334H14.1111V14.8889H19.4666V12.8889H16.1111V9.53334Z'
            fill='#4286F5'
          />
        </svg>
      )
    case 'total-accounts':
      return (
        <svg
          className={classSvg}
          width='28'
          height='28'
          viewBox='0 0 28 28'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M0 0H28V28H0V0Z' fill='white' />
          <path
            d='M26 6V5C26 3.89543 25.1046 3 24 3H4C2.89543 3 2 3.89543 2 5V6M2 12V17C2 18.1046 2.89543 19 4 19H10.5M13.5 19H11.5'
            stroke='#A3CEF1'
            stroke-width='2'
          />
          <path d='M1 7H27V11H1V7Z' fill='#4286F5' />
          <path d='M4 12H16L14 14H4V12Z' fill='#4286F5' />
          <path
            d='M24 14V22.5M24 22.5L21 19.5M24 22.5L27 19.5'
            stroke='#4286F5'
            stroke-width='2'
          />
          <path
            d='M18 24V15.5M18 15.5L15 18.5M18 15.5L21 18.5'
            stroke='#4286F5'
            stroke-width='2'
          />
        </svg>
      )
    case 'bad-credit':
      return (
        <svg
          className={classSvg}
          width='28'
          height='28'
          viewBox='0 0 28 28'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M0 0H28V28H0V0Z' fill='white' />
          <circle
            cx='14.5'
            cy='23.5'
            r='2.5'
            stroke='#4286F5'
            stroke-width='2'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M27 12.4143L16.7072 22.7071L15.293 21.2929L27 9.58586V12.4143Z'
            fill='#4286F5'
          />
          <circle
            r='2.5'
            transform='matrix(-1 0 0 1 23.5 23.5)'
            stroke='#4286F5'
            stroke-width='2'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M19.4142 18L22.707 21.2929L21.2928 22.7071L16.5857 18H19.4142Z'
            fill='#4286F5'
          />
          <path
            d='M27 1H1V12L6 17H18L21.2673 13.7674L19.8166 12.3166L17.1716 15H7L3 11V3H25V7H27V1Z'
            fill='#A3CEF1'
          />
          <path
            d='M21.3058 10.8058L22.7753 12.2754L26.0858 9H23.0858L21.3058 10.8058Z'
            fill='#A3CEF1'
          />
          <path
            d='M15 11.8726L14.9953 13H10.019V11.8726H10.4123C10.5545 11.8329 10.654 11.7046 10.7109 11.4878C10.7678 11.271 10.7962 11.0253 10.7962 10.7507L10.7678 9.76965H10V8.66396H10.7346L10.6967 7.36856C10.6967 6.88076 10.7867 6.45799 10.9668 6.10027C11.1501 5.74255 11.4044 5.46974 11.7299 5.28184C12.0553 5.09395 12.4281 5 12.8483 5C13.2812 5 13.6524 5.09214 13.9621 5.27642C14.2749 5.45709 14.5118 5.71364 14.673 6.04607C14.8373 6.37489 14.9194 6.7579 14.9194 7.19512H13.7299C13.7299 6.82656 13.643 6.55736 13.4692 6.38753C13.2954 6.21409 13.0742 6.12737 12.8057 6.12737C12.6382 6.12737 12.4866 6.17615 12.3507 6.27371C12.218 6.36766 12.1137 6.50858 12.0379 6.69648C11.9621 6.88437 11.9242 7.1084 11.9242 7.36856L11.9668 8.66396H13.4408V9.76965H12L12.0332 10.7019C12.0332 11.1897 11.9321 11.5799 11.7299 11.8726H15Z'
            fill='#4286F5'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M6 12H2V10H8V16H6V12Z'
            fill='#A3CEF1'
          />
          <path d='M27 17H24L27 14V17Z' fill='#A3CEF1' />
        </svg>
      )
    case 'stability':
      return (
        <svg
          className={classSvg}
          width='28'
          height='28'
          viewBox='0 0 28 28'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path d='M0 0H28V28H0V0Z' fill='white' />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M24 25H4V23H24V25Z'
            fill='#4286F5'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M13 20H7V22H21V20H15V5H13V20Z'
            fill='#A3CEF1'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M5.5 8L2 18H9L5.5 8ZM5.5 14.0542L4.81896 16H6.18104L5.5 14.0542Z'
            fill='#4286F5'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M22.5 6L19 16H26L22.5 6ZM22.5 12.0542L21.819 14H23.181L22.5 12.0542Z'
            fill='#4286F5'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M22.6167 4.99315L5.61674 6.99315L5.38306 5.00685L22.3831 3.00685L22.6167 4.99315Z'
            fill='#A3CEF1'
          />
          <circle cx='14' cy='5' r='2' fill='#A3CEF1' />
        </svg>
      )
    case 'blub':
      return (
        <svg
          className={`svg-icon svg-icon_blub ${classSvg ? classSvg : ''}`}
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M11.1429 5.14287V2.57144H12.8572V5.14287H11.1429Z'
            fill='#C3C8CF'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M15.6366 6.29414L17.4548 4.47586L18.667 5.68805L16.8487 7.50632L15.6366 6.29414ZM5.33301 16.5977L7.15128 14.7794L8.36347 15.9916L6.54519 17.8099L5.33301 16.5977Z'
            fill='#C3C8CF'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M18 10.2857H20.5714V12H18V10.2857ZM3.42859 10.2857H6.00002V12H3.42859L3.42859 10.2857Z'
            fill='#C3C8CF'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M16.8487 14.7794L18.667 16.5977L17.4548 17.8099L15.6366 15.9916L16.8487 14.7794ZM6.5452 4.47586L8.36347 6.29414L7.15129 7.50632L5.33301 5.68804L6.5452 4.47586Z'
            fill='#C3C8CF'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M12.8572 14.6089L13.7131 14.1138C14.7424 13.5184 15.4286 12.4098 15.4286 11.1429C15.4286 9.24931 13.8936 7.71429 12 7.71429C10.1065 7.71429 8.57146 9.24931 8.57146 11.1429C8.57146 12.4098 9.25772 13.5184 10.287 14.1138L11.1429 14.6089V17.1429H12.8572V14.6089ZM14.5715 15.5977V17.5714C14.5715 18.2815 13.9958 18.8571 13.2857 18.8571H10.7143C10.0042 18.8571 9.42861 18.2815 9.42861 17.5714V15.5977C7.8914 14.7085 6.85718 13.0464 6.85718 11.1429C6.85718 8.30254 9.15971 6 12 6C14.8404 6 17.1429 8.30254 17.1429 11.1429C17.1429 13.0464 16.1087 14.7085 14.5715 15.5977Z'
            fill='#C3C8CF'
          />
          <path
            d='M9.42859 20.5714C9.42859 20.0981 9.81234 19.7143 10.2857 19.7143H13.7143C14.1877 19.7143 14.5714 20.0981 14.5714 20.5714C14.5714 21.0448 14.1877 21.4286 13.7143 21.4286H10.2857C9.81234 21.4286 9.42859 21.0448 9.42859 20.5714Z'
            fill='#C3C8CF'
          />
        </svg>
      )
    case 'union':
      return (
        <svg
          className={`svg-icon svg-icon_union ${classSvg ? classSvg : ''}`}
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M13.6071 10.75L14.5 4.5L7 13.25H10.3929L9.5 19.5L17 10.75H13.6071Z'
            fill='#C3C8CF'
          />
        </svg>
      )
    case 'IconFacebook':
      return (
        <svg
          className={`svg-icon svg-icon_union ${classSvg ? classSvg : ''}`}
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clip-path='url(#clip0)'>
            <path
              d='M22.6754 24.0001C23.4068 24.0001 24 23.407 24 22.6755V1.32459C24 0.592969 23.4068 0 22.6754 0H1.32459C0.592875 0 0 0.592969 0 1.32459V22.6755C0 23.407 0.592875 24.0001 1.32459 24.0001H22.6754Z'
              fill='#395185'
            />
            <path
              d='M16.5595 24.0003V14.7062H19.6792L20.1463 11.0841H16.5595V8.7715C16.5595 7.72281 16.8508 7.00816 18.3546 7.00816L20.2727 7.00731V3.76778C19.9408 3.72362 18.8023 3.625 17.4778 3.625C14.7123 3.625 12.8192 5.31297 12.8192 8.41291V11.0841H9.69147V14.7062H12.8192V24.0003H16.5595Z'
              fill='white'
            />
          </g>
          <defs>
            <clipPath id='clip0'>
              <rect width='24' height='24' fill='white' />
            </clipPath>
          </defs>
        </svg>
      )
    case 'IconTwitter':
      return (
        <svg
          className={`svg-icon svg-icon_union ${classSvg ? classSvg : ''}`}
          width='29'
          height='24'
          viewBox='0 0 29 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M28.9986 2.92233C27.9316 3.40199 26.7851 3.72616 25.5817 3.872C26.8101 3.12559 27.7533 1.94362 28.1975 0.53531C27.0297 1.23784 25.7521 1.73281 24.4198 1.99885C23.3346 0.826755 21.7885 0.0942383 20.0774 0.0942383C16.7918 0.0942383 14.1281 2.79464 14.1281 6.12524C14.1281 6.59801 14.1807 7.05826 14.2821 7.49979C9.33787 7.24819 4.95432 4.84716 2.02005 1.19824C1.50807 2.08899 1.2147 3.12513 1.2147 4.23028C1.2147 6.32276 2.26506 8.16869 3.86126 9.2503C2.91653 9.2203 1.99258 8.96162 1.16656 8.49585C1.16622 8.52111 1.16622 8.54637 1.16622 8.57175C1.16622 11.4939 3.21687 13.9316 5.9383 14.4856C5.06225 14.7272 4.14334 14.7625 3.25175 14.589C4.00874 16.9851 6.20584 18.7287 8.80902 18.7775C6.77298 20.395 4.20775 21.3593 1.42063 21.3593C0.940362 21.3593 0.466892 21.3307 0.00146484 21.275C2.6342 22.9862 5.76125 23.9847 9.12085 23.9847C20.0635 23.9847 26.0473 14.7945 26.0473 6.82469C26.0473 6.5631 26.0416 6.303 26.0301 6.0444C27.1947 5.19083 28.2 4.13361 28.9986 2.92233Z'
            fill='#55ACEE'
          />
        </svg>
      )
    case 'IconWhatsapp':
      return (
        <svg
          className={`svg-icon svg-icon_union ${classSvg ? classSvg : ''}`}
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g filter='url(#filter0_f)'>
            <path
              d='M0.591919 23.4398L2.19997 17.5945C1.21124 15.8841 0.68425 13.9411 0.689686 11.9548C0.689686 5.73047 5.77472 0.669922 12.0225 0.669922C15.0539 0.669922 17.9007 1.84443 20.0358 3.97688C22.1763 6.10933 23.3552 8.94544 23.3498 11.9602C23.3498 18.1844 18.2647 23.245 12.017 23.245H12.0116C10.1156 23.245 8.25208 22.7688 6.5951 21.8702L0.591919 23.4398ZM6.87762 19.8243L7.21985 20.0301C8.66499 20.8852 10.322 21.3344 12.0116 21.3398H12.017C17.2053 21.3398 21.4319 17.1344 21.4319 11.9602C21.4319 9.4542 20.4541 7.09987 18.6776 5.32452C16.9011 3.54927 14.5323 2.57507 12.017 2.57507C6.82325 2.57507 2.59657 6.78049 2.59657 11.9547C2.59657 13.7246 3.09094 15.4511 4.03627 16.945L4.25899 17.3022L3.30832 20.7607L6.87762 19.8243Z'
              fill='black'
              fill-opacity='0.24'
            />
          </g>
          <path
            d='M1.10602 22.8363L2.64049 17.2612C1.69429 15.6259 1.19655 13.7715 1.19722 11.884C1.19722 5.95073 6.04754 1.12402 11.9976 1.12402C14.8895 1.12402 17.5991 2.24651 19.6379 4.27764C21.6766 6.30886 22.7981 9.01358 22.7981 11.8893C22.7981 17.8224 17.9478 22.6491 11.9977 22.6491H11.9923C10.1841 22.6491 8.4082 22.1948 6.8308 21.3396L1.10602 22.8364V22.8363Z'
            fill='url(#paint0_linear)'
          />
          <path
            d='M0.714355 23.2265L2.30244 17.4537C1.32599 15.7647 0.805468 13.8457 0.810904 11.884C0.810904 5.73705 5.83285 0.739258 12.0031 0.739258C14.9968 0.739258 17.8082 1.8991 19.9169 4.00513C22.0307 6.11115 23.195 8.91205 23.1897 11.8894C23.1897 18.0363 18.1678 23.0341 11.9975 23.0341H11.9923C10.1234 23.0334 8.28443 22.5666 6.64302 21.6764L0.714355 23.2266V23.2265ZM6.92198 19.6559L7.25999 19.859C8.68723 20.7036 10.3236 21.1473 11.9923 21.1526H11.9976C17.1215 21.1526 21.2958 16.9994 21.2958 11.8894C21.2958 9.41456 20.33 7.08936 18.5755 5.33614C16.821 3.58293 14.4817 2.62078 11.9976 2.62078C6.86836 2.62078 2.69417 6.774 2.69417 11.884C2.69417 13.6319 3.18235 15.337 4.11597 16.8123L4.33597 17.1651L3.39701 20.5806L6.92198 19.6559Z'
            fill='white'
          />
          <path
            d='M9.2023 7.21789C8.99298 6.75283 8.77298 6.74209 8.57454 6.73677C8.4136 6.73145 8.22584 6.73145 8.03799 6.73145C7.85024 6.73145 7.54972 6.80092 7.29222 7.07884C7.03463 7.35685 6.31567 8.03034 6.31567 9.40413C6.31567 10.7724 7.31903 12.098 7.45851 12.2851C7.59799 12.4722 9.39539 15.3746 12.2336 16.4918C14.5944 17.4219 15.0773 17.2348 15.587 17.1867C16.1021 17.1386 17.2396 16.5132 17.4756 15.8611C17.7063 15.209 17.7063 14.653 17.6365 14.5355C17.5668 14.4178 17.379 14.3484 17.1 14.2094C16.821 14.0704 15.4475 13.3969 15.19 13.3007C14.9324 13.2045 14.7447 13.1618 14.5623 13.4397C14.3744 13.7176 13.838 14.343 13.6769 14.5301C13.516 14.7172 13.3497 14.7386 13.0706 14.5996C12.7917 14.4607 11.8903 14.1666 10.8226 13.2152C9.991 12.4775 9.42764 11.5635 9.2666 11.2856C9.10565 11.0076 9.25057 10.8579 9.39005 10.719C9.51341 10.596 9.66901 10.3929 9.80859 10.2326C9.94807 10.0722 9.99634 9.95464 10.0875 9.76749C10.1788 9.58044 10.1358 9.4201 10.0661 9.28114C9.99634 9.14209 9.44911 7.76839 9.2023 7.21789Z'
            fill='white'
          />
          <defs>
            <filter
              id='filter0_f'
              x='0.0316077'
              y='0.109611'
              width='23.8785'
              height='23.8906'
              filterUnits='userSpaceOnUse'
              color-interpolation-filters='sRGB'
            >
              <feFlood flood-opacity='0' result='BackgroundImageFix' />
              <feBlend
                mode='normal'
                in='SourceGraphic'
                in2='BackgroundImageFix'
                result='shape'
              />
              <feGaussianBlur
                stdDeviation='0.280156'
                result='effect1_foregroundBlur'
              />
            </filter>
            <linearGradient
              id='paint0_linear'
              x1='11.9516'
              y1='22.8348'
              x2='11.9516'
              y2='1.12272'
              gradientUnits='userSpaceOnUse'
            >
              <stop stop-color='#20B038' />
              <stop offset='1' stop-color='#60D66A' />
            </linearGradient>
          </defs>
        </svg>
      )
    case 'IconTelegram':
      return (
        <svg
          className={`svg-icon svg-icon_union ${classSvg ? classSvg : ''}`}
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M12 0C5.37253 0 0 5.37253 0 12C0 18.6275 5.37253 24 12 24C18.6275 24 24 18.6275 24 12C24 5.37253 18.6275 0 12 0Z'
            fill='#40B3E0'
          />
          <path
            d='M17.839 6.90313L15.6956 17.7096C15.6956 17.7096 15.3959 18.459 14.5715 18.0993L9.62545 14.3073L7.82695 13.4381L4.79939 12.4188C4.79939 12.4188 4.33476 12.254 4.28976 11.8943C4.24476 11.5346 4.81439 11.3398 4.81439 11.3398L16.8496 6.6185C16.8496 6.6185 17.839 6.18369 17.839 6.90313Z'
            fill='white'
          />
          <path
            d='M9.2454 17.5877C9.2454 17.5877 9.10103 17.5742 8.92103 17.0046C8.74131 16.4351 7.82697 13.4375 7.82697 13.4375L15.0962 8.82126C15.0962 8.82126 15.5159 8.56645 15.5009 8.82126C15.5009 8.82126 15.5758 8.86626 15.3509 9.07607C15.1262 9.28598 9.64056 14.2169 9.64056 14.2169'
            fill='#D2E5F1'
          />
          <path
            d='M10.8803 15.9768L8.92401 17.7605C8.92401 17.7605 8.77101 17.8766 8.60376 17.8038L8.97839 14.4907'
            fill='#B5CFE4'
          />
        </svg>
      )
    default:
      return ''
  }
}
export default Icon
